import { useContext } from 'react'
import { QuoteContext } from './QuoteContext'

export function useQuote() {
  return useContext(QuoteContext)
}
